(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3945],{

/***/ 66242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/cardClasses.js


function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/Card.js
'use client';



const _excluded = ["className", "raised"];










const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};
const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiCard'
  });
  const {
      className,
      raised = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    raised
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);

/***/ }),

/***/ 90629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Paper_Paper; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/system/colorManipulator.js
var colorManipulator = __webpack_require__(2101);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/getOverlayAlpha.js
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const getOverlayAlpha = elevation => {
  let alphaValue;
  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2;
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }
  return (alphaValue / 100).toFixed(2);
};
/* harmony default export */ var styles_getOverlayAlpha = (getOverlayAlpha);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Paper/paperClasses.js


function getPaperUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiPaper', slot);
}
const paperClasses = (0,generateUtilityClasses/* default */.Z)('MuiPaper', ['root', 'rounded', 'outlined', 'elevation', 'elevation0', 'elevation1', 'elevation2', 'elevation3', 'elevation4', 'elevation5', 'elevation6', 'elevation7', 'elevation8', 'elevation9', 'elevation10', 'elevation11', 'elevation12', 'elevation13', 'elevation14', 'elevation15', 'elevation16', 'elevation17', 'elevation18', 'elevation19', 'elevation20', 'elevation21', 'elevation22', 'elevation23', 'elevation24']);
/* harmony default export */ var Paper_paperClasses = ((/* unused pure expression or super */ null && (paperClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Paper/Paper.js
'use client';



const _excluded = ["className", "component", "elevation", "square", "variant"];













const useUtilityClasses = ownerState => {
  const {
    square,
    elevation,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, !square && 'rounded', variant === 'elevation' && `elevation${elevation}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getPaperUtilityClass, classes);
};
const PaperRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiPaper',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], !ownerState.square && styles.rounded, ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$vars$overlays;
  return (0,esm_extends/* default */.Z)({
    backgroundColor: (theme.vars || theme).palette.background.paper,
    color: (theme.vars || theme).palette.text.primary,
    transition: theme.transitions.create('box-shadow')
  }, !ownerState.square && {
    borderRadius: theme.shape.borderRadius
  }, ownerState.variant === 'outlined' && {
    border: `1px solid ${(theme.vars || theme).palette.divider}`
  }, ownerState.variant === 'elevation' && (0,esm_extends/* default */.Z)({
    boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
  }, !theme.vars && theme.palette.mode === 'dark' && {
    backgroundImage: `linear-gradient(${(0,colorManipulator/* alpha */.Fq)('#fff', styles_getOverlayAlpha(ownerState.elevation))}, ${(0,colorManipulator/* alpha */.Fq)('#fff', styles_getOverlayAlpha(ownerState.elevation))})`
  }, theme.vars && {
    backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
  }));
});
const Paper = /*#__PURE__*/react.forwardRef(function Paper(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiPaper'
  });
  const {
      className,
      component = 'div',
      elevation = 1,
      square = false,
      variant = 'elevation'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    component,
    elevation,
    square,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  if (false) {}
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PaperRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ownerState: ownerState,
    className: (0,clsx/* default */.Z)(classes.root, className),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Paper_Paper = (Paper);

/***/ }),

/***/ 81787:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/appTimeline",
      function () {
        return __webpack_require__(61502);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84538:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/11.86026da2.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA9UlEQVR42hXKvUrDUBiH8f97zkmkxhowIDi6qYOL4uzQrYsiuHsJ3oIX4OwmuDm5GDq6OHgDFR1rIygFrW1jkvPxvm2f9ffQ6f3oQhN1Y4XSM5QVgQAcESUskhti7tYsZ4UXZIbQUgABqBmIFEH1p1V5mDIudyI7rutw3UnD7UlmD9KA91lVGuusshY4P9rSnd223mjHEBEUfw3WOSi1px16xRRvwwmWuKz/McHj9wyb5KD+m4YzeHz9VsF5Dq+DcbjqDcI2eVQLM87ZBES4e/mMb56HePhx2F9Rek3TYpDEgDlvBHgaubJFUMerGo6ZrUdChHwOGAl8LfDGLzAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 79711:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/15.e11c799e.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAIAAABLbSncAAAA00lEQVR42mMQXfVXZNVfydV/OVf9ZVjwh2HhH+nVIBEGgUW/RBb/Yl30S33Jr9Xnfy8584dhwS+Jxb8YuGZ8VZv1laHry46LP////7vr4k+GqV/FZ35l4O35KNv3kaHtw+2nv64//sVQ+0G5/yNXz0cG+eY3DMWvTl///v//PyA6d/M7Q8lrOaAgZ9lzhtLnrk0v7j/98fDZD+v6Fwwlz7mBggxZj1UKnjA4PLh06+vVO18ZnB4AuUBBBobkB/LpDxlc7l29/fXG3a8MrvfkgNzkBwAlaHR/cn2xQAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 69489:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/16.b0f4cb05.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA9UlEQVR42mOAgfvRAbF3woPW3wkJWH8/2juWARnc9HebecfX8f9DZ4H/D5yY/t+ysPh/Xcd5JkR2eVbsumSn/4+SQv+cX334z7n1h/68nBf4580c4/9fNrrEMDCszlsfN8Hx/4llB/+4z/3/X3fiv/8PLh768/8i4/+/Z3zWM6gtyljPsND7/4K9x/7kTvr337Xn7/+75w7/+X+e+/+fs0AFGguTYhjmR/8PXJX7Z8a+Y3/m7Tr65+f5iD//z1r+/3PGLQbsDMX5cTMF5oX/Z5ju9H//JrX//89b/P99GuJIBJgXHxMwO3b9txM+6/+fc42BCQMALP+AFtMto2sAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 57614:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/17.5c307e48.svg","height":44,"width":44});

/***/ }),

/***/ 49967:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/18.74eca1d7.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA5klEQVR42lWPO2sCQRSFJ2XqFGmENIEkViH/LKQKIUiKEIL/QRufpZbrzAjjG5TVRt1xBV18oOiAIMIyxXFmC8ELt7nnnnPvR2wBeFFSCi+b07aVnAg7u4hzShWLPaP3nUAv8QP+EMecMhUtWSd/esWy2QpnjoNFrY6N64Y8/gabRMaZrHZ//7BsNBDwKtj9I7aDAfr/SXhGIzJf0J33D5uAQxCA3cawG47Q/fyCZzSiJr6ghFhHeFyvsWp3TBIPKbmD8n0RPTktldUwlYYhACU30ZmAcXVFctrvxcypaFkoauO8YJ4BYV21J40VIu8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 4201:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/19.a0fb6d13.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA3ElEQVR42kWPPUsDQRiE7yf5j+ys7JQt/Q2ChaTRKmKbC4nRSpAVFCURREQLCxNC7iu3e/vuXjb3ZvJxJBmYZp4pZoKttLVCM8uNy1LU6R6GKo6Q3d8h6XYxHY6QF0VYQ7JiDaPjI59eNdjcXLL7fPWFI0zTTAS5W0j73YZ/POdkBvQGJTovxH//CmSUDPSqoH7a+B1cMBHw/Fbi4Iz4qa8wn+UyIGNFnMU4bJ34hrzm2/cmnza/fBQbGJPVY6mgcJJG6Hw8oNXvYZwMQfXIvUgbUbm5rFwlSbvdzSWzoLMLtNFDUQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 59535:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/19.5679bc9c.webp","height":500,"width":500,"blurDataURL":"data:image/webp;base64,UklGRrgAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDUAAAABYFTbtpL7fyJcE8EMIvjoJxYOFiIiwipZllRWA8CoFLyHbMWDZ9//ZwneQ60JYJZR51wvAwBWUDggXAAAABACAJ0BKggACAACQDglqAJ0bX8Cf/ZavwAA/uF7p+CX9JNUfAujS/l7nzfxrUS6AJ+/N8rDpz09Xa6EmSKsOH87DcKQIfs9z/+qEaDn6QY+1IVdsn6sw23bG5gA","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 88101:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/21.fbc5244f.webp","height":256,"width":256,"blurDataURL":"data:image/webp;base64,UklGRmgAAABXRUJQVlA4IFwAAAAwAgCdASoIAAgAAkA4JbACdG1/AvJ6mk/kgAD+9V8xK7aNYidyuvn2g0ZxDfaWrvhjbNtsMcz9wVv2LPD535g3rjPftuXRF31f2Gv1gPnwBy+s6/Jv5y/5UQAAAA==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 95598:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/22.88cba043.webp","height":190,"width":190,"blurDataURL":"data:image/webp;base64,UklGRjwAAABXRUJQVlA4IDAAAACwAQCdASoIAAgAAkA4JaQAAud7cY6AAP7903IdG/csJky5UrmwLHI9itWZzYdZAAA=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 47234:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/7.c1a6ff67.png","height":300,"width":300,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAzElEQVR42mN4oKXKyIADwOWeG2iJPVVXMHtub23x3Nvd4qmGotlzfU0xsOQtDWWOBxrKNx4a6Py/z8AAxg/1tf8/0FS5cUtNiYPhiqqy/HVdnS9XgRJvjxz582D+/D8g9nUdrS9X1FTkGY7JKcidUdP4foqB4f/jTZv+3+jr+w9in1FV+w6SY1guKs56QFTq5EFF1f/7GBj+gPBBBZX/B8SkT64QFmVlAIFOCRmulQxMyht8/FTXe3iprmRgU+4RleICS+4Rl8HmTbgcAIKzT0pjg1p+AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 47206:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/8.59b9a5ea.jpg","height":180,"width":180,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAgACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABgEBAAAAAAAAAAAAAAAAAAAAAv/aAAwDAQACEAMQAAAAkQn/AP/EAB4QAAEEAQUAAAAAAAAAAAAAAAIBAwQSEQAFBmKi/9oACAEBAAE/ABDZYvHnHLtSJckGsIpJdg0UrYHr61//xAAXEQADAQAAAAAAAAAAAAAAAAAAAREh/9oACAECAQE/AFtP/8QAFxEBAAMAAAAAAAAAAAAAAAAAAQARcf/aAAgBAwEBPwBArJ//2Q==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 61502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _public_images_apps_7_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47234);
/* harmony import */ var _public_images_apps_8_jpg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47206);
/* harmony import */ var _public_images_apps_11_png__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84538);
/* harmony import */ var _public_images_apps_17_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57614);
/* harmony import */ var _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49967);
/* harmony import */ var _public_images_apps_19_png__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4201);
/* harmony import */ var _public_images_apps_15_png__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79711);
/* harmony import */ var _public_images_apps_16_png__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69489);
/* harmony import */ var _public_images_apps_19_webp__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59535);
/* harmony import */ var _public_images_apps_21_webp__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88101);
/* harmony import */ var _public_images_apps_22_webp__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95598);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(66242);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1954);
















function index() {
    const APPLICATIONS = [
        {
            id: 1,
            title: "Telegram",
            img: _public_images_apps_17_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
            time: "12:45 PM",
            size: "43s"
        },
        {
            id: 25,
            title: "Safari",
            img: _public_images_apps_19_webp__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
            time: "10:18 PM",
            size: "23s"
        },
        {
            id: 26,
            title: "Safari",
            img: _public_images_apps_19_webp__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
            time: "10:10 PM",
            size: "52s"
        },
        {
            id: 27,
            title: "Music",
            img: _public_images_apps_21_webp__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z,
            time: "09:10 PM",
            size: "33s"
        },
        {
            id: 2,
            title: "TikTok",
            img: _public_images_apps_8_jpg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
            time: "12:35 PM",
            size: "10s"
        },
        {
            id: 3,
            title: "TikTok",
            img: _public_images_apps_8_jpg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
            time: "12:35 PM",
            size: "15s"
        },
        {
            id: 29,
            img: _public_images_apps_22_webp__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
            title: "Shadowrocket",
            time: "12:20 PM",
            size: "12m 3s"
        },
        {
            id: 4,
            title: "TikTok",
            img: _public_images_apps_8_jpg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
            time: "12:34 PM",
            size: "59s"
        },
        {
            id: 5,
            title: "Twitter",
            img: _public_images_apps_11_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
            time: "12:34 PM",
            size: "13s"
        },
        {
            id: 6,
            title: "Telegram",
            img: _public_images_apps_17_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
            time: "12:22 PM",
            size: "43s"
        },
        {
            id: 7,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "12:10 PM",
            size: "2m 3s"
        },
        {
            id: 8,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "12:01 PM",
            size: "6m 3s"
        },
        {
            id: 9,
            title: "Gmail",
            img: _public_images_apps_19_png__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
            time: "11:13 PM",
            size: "30s"
        },
        {
            id: 10,
            title: "TikTok",
            img: _public_images_apps_8_jpg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
            time: "11:10 PM",
            size: "54s"
        },
        {
            id: 11,
            title: "Twitter",
            img: _public_images_apps_11_png__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
            time: "10:42 PM",
            size: "14s"
        },
        {
            id: 12,
            title: "Telegram",
            img: _public_images_apps_17_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
            time: "9:19 PM",
            size: "8m 6s"
        },
        {
            id: 13,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "9:01 PM",
            size: "6m 39s"
        },
        {
            id: 14,
            title: "Gmail",
            img: _public_images_apps_19_png__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
            time: "8:13 PM",
            size: "30s"
        },
        {
            id: 15,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "11:55 PM",
            size: "2m 43s"
        },
        {
            id: 16,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "11:40 PM",
            size: "2m 3s"
        },
        {
            id: 17,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "11:30 PM",
            size: "1m 3s"
        },
        {
            id: 18,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "11:22 PM",
            size: "33s"
        },
        {
            id: 19,
            title: "Pinterest",
            img: _public_images_apps_18_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
            time: "11:18 PM",
            size: "1m 2s"
        },
        {
            id: 20,
            title: "Chrome Browser",
            img: _public_images_apps_19_png__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
            time: "11:01 PM",
            size: "5m 3s"
        },
        {
            id: 21,
            title: "Chrome Browser",
            img: _public_images_apps_19_png__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
            time: "10:30 PM",
            size: "2m 3s"
        },
        {
            id: 22,
            title: "Facebook",
            img: _public_images_apps_15_png__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
            time: "12:10 PM",
            size: "43s"
        },
        {
            id: 23,
            title: "Chrome Browser",
            img: _public_images_apps_16_png__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
            time: "12:13 PM",
            size: "2m 32s"
        },
        {
            id: 24,
            title: "Chrome Browser",
            img: _public_images_apps_16_png__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
            time: "10:20 PM",
            size: "2m 3s"
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            class: "bg-[#f5f6fa] p-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "md:w-2/3 sm:w-11/12 mx-auto bg-white rounded-lg",
                children: APPLICATIONS.map((app)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex h-[70px] items-center justify-between w-11/12 mx-auto",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_13___default()), {
                                            src: app.img,
                                            alt: "img",
                                            className: "w-[35px] h-[35px] rounded-xl"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "ml-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "font-semibold text-opacity-50 text-black",
                                                children: app.title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[13px] text-opacity-60 text-black",
                                                children: app.time
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "grid justify-items-end",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-[0.875rem] font-medium text-black text-opacity-60",
                                        children: app.size
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_14__/* .Icon */ .JO, {
                                        icon: "mdi:ellipsis-horizontal"
                                    })
                                ]
                            })
                        ]
                    }, app.id);
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,1954,9774,2888,179], function() { return __webpack_exec__(81787); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);